import OriginationApplicationClientType from "./OriginationApplicationClientTypeEnum";
import IExistingClient from "@/module/main/dto/origination-v2/IExistingClient";
import IOriginationApplicationClient from "@/module/main/dto/origination-v2/IOriginationApplicationClient";

export default class OriginationApplicationClient implements IOriginationApplicationClient
{
    constructor(public existingClient: IExistingClient,
                public type: OriginationApplicationClientType
    )
    {
    }
}
